const _ = require("lodash");
const moment = require("moment");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const TrainerCore = require("../../../shared/TrainerCore");
const URLMake = require("../../../shared/URLMake");
const OpsBlock = require("../../core/vault/OpsBlock");
const OpsUser = require("../../core/vault/OpsUser");
const AT = require("../../core/vault/ActionTypes");
const {atDemo} = require("../../core/vault/StateCursors");
const withSetURL = require("../../core/hoc/withSetURL");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const QuadUtil = require("../../core/util/QuadUtil");
const ChooseOptionModal = require("../../core/view/ChooseOptionModal");
const StudentLink = require("../../core/view/StudentLink");
const Quad = require("../../core/view/Quad");
const MessageModal = require("../../core/view/MessageModal");
const PartialProgressBar = require("../../core/view/PartialProgressBar");
const BlockStar = require("./BlockStar");
const Tooltip = require("../../core/view/Tooltip");
const CopyTable = require("../../core/util/CopyTable");
const AssetsUtil = require("../../core/util/AssetsUtil");
const {FLAGS} = require("../../core/util/GlobalFlags");
const Sounds = require("../../core/util/Sounds");
const ToDoClip = require("./ToDoClip");

const styles = require("./styles/BlockButton.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withSetURL(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => {
		return {
			demoReplayBlockId: atDemo(vaultState).getIn(["actions", "replayLesson"]),
		};
	});
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "BlockButton",

		propTypes: {
			user: PT.object.isRequired,
			block: PT.object.isRequired,
			assignedBlock: PT.object,
			chapter: PT.object.isRequired,
			blockShapeNum: PT.number.isRequired,
			numUnfinishedBlocks: PT.number.isRequired,
			skipUnfinishedMessage: PT.bool,
			homework: PT.object,
			smaller: PT.bool,
			largerTitle: PT.bool,
			isForTheater: PT.bool,
			onButtonClick: PT.func,
			titleClassName: PT.string,
			demo: PT.bool,
			demoHighlight: PT.bool,
			topText: PT.string,

			// Used for tutorial
			disableLink: PT.bool,
			starTooltipClass: PT.string,
			overrideStarClick: PT.func,
			scale: PT.number,
			overrideBeastClass: PT.string,
			overrideTitleContainerClass: PT.string,
			overrideStarsObtained: PT.number,
			disableStarTooltip: PT.bool,
			appendSvgClass: PT.string,

			// Injected by HOCs
			demoReplayBlockId: PT.number,
			setURL: PT.func.isRequired,
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				isModalOpen: false,
				historyModalType: false,
			};
		},

		startBlock: function() {
			const url = this.props.demo
				? URLMake.forDemo(URLMake.state.forBlock(this.props.block))
				: URLMake.forBlock(this.props.block);
			this.props.setURL(url);
		},

		isUnlocked: function() {
			return OpsBlock.isUnlocked(this.props.block, this.props.chapter);
		},

		renderBlockBackground: function(gradeNumber, shapeNum) {
			const quad = QuadUtil.getBlockButtonSet(shapeNum, this.props.smaller);
			let scaledQuad = quad;
			if (this.props.scale) {
				scaledQuad = (w, h) => {
					return quad(w, h).map(a => a * this.props.scale);
				};
			}
			const backgroundClass = styles["grade" + gradeNumber + "Block"];
			const borderClass = styles["grade" + gradeNumber + "BlockBorder"];
			let quadClass = styles.quadWrapper;
			if (!this.props.isForTheater) {
				quadClass += ` ${styles.quadWrapperWidth}`;
			}
			// Block buttons have no blur because giving them soft shadows makes safari
			// turn them into hard shadows after a few actions - must use hard shadows
			// for blocks

			// appendSvgClass is used by the tutorial to set the cursor on JUST
			// the SVG, since in the tutorial the SVG is scaled up
			const svgClass = (this.props.appendSvgClass || "") + " " + styles.quadSvg;
			return (
				<div className={quadClass}>
					<Quad
						quad={scaledQuad}
						backgroundClass={backgroundClass}
						borderClass={borderClass}
						svgClass={svgClass}
						borderWidths={[0.33, 0, 0, 0.25]}
						borderUnits="rem"
						shadowOffset={5}
						shadowOpacity={0.4}
					/>
				</div>
			);
		},

		renderToDoClip: function(showNote) {
			const toDoEl = (
				<ToDoClip
					className={styles.todoClip}
					showNote={showNote}
					direction={"left"}
				/>
			);
			const {starsObtained} = this.props.block.model;
			const tooltipText = starsObtained
				? CopyTable.tooltipText.completeAssignmentIcon
				: CopyTable.tooltipText.incompleteAssignmentIcon;
			return this.isUnlocked() ? (
				<Tooltip tooltipText={tooltipText} size={"medium"} stretchWidth={true}>
					{toDoEl}
				</Tooltip>
			) : (
				toDoEl
			);
		},

		renderTrophy: function(isSmall) {
			const {block} = this.props;
			const blockModel = block.model;
			if (blockModel.isTrophyAvailable) {
				const trophyURL = URLMake.forTrophyProblem(block);
				return (
					<Tooltip tooltipText={CopyTable.tooltipText.trophy} size="medium">
						<BlockStar
							className={isSmall ? styles.trophySmall : styles.trophy}
							type={
								blockModel.isTrophyComplete
									? "trophy-earned"
									: "trophy-unearned"
							}
							linkTo={trophyURL}
							clickSound={"squishy"}
							shadowOffset={2}
						/>
					</Tooltip>
				);
			}
			return null;
		},

		renderUnfinishedIcon: function(isSmall) {
			const {percentComplete} = this.props.block.model;
			if (percentComplete && percentComplete !== 1) {
				return (
					<PartialProgressBar
						className={isSmall ? styles.unfinishedSmall : styles.unfinished}
						percentComplete={percentComplete}
					/>
				);
			} else {
				return null;
			}
		},

		renderLockIcon: function(forUnderConstruction) {
			let lockClass = this.props.smaller ? styles.smallerLock : styles.lock;
			if (this.props.topText) lockClass = styles.lockWithTopText;
			return (
				<img
					className={lockClass}
					src={AssetsUtil.getBlockLock(this.props.blockShapeNum)}
				/>
			);
		},

		renderConstructionIcon: function() {
			const iconClass = this.props.smaller
				? styles.smallConstructionIcon
				: styles.constructionIcon;
			return (
				<img className={iconClass} src={AssetsUtil.getUnderConstruction()} />
			);
		},

		renderBonusBeastIcon: function(isUnlocked) {
			const {block, smaller, isForTheater} = this.props;
			const blockModel = block.model;
			const requirementLevel = _.get(blockModel, "requirementLevel");
			const isBonus = TrainerCore.isBonusBlock(requirementLevel);
			if (!isBonus) {
				return null;
			}
			let bonusBeastClass = styles["grade" + blockModel.gradeNumber + "Block"];
			let bonusBeastBorderClass =
				styles["grade" + blockModel.gradeNumber + "BlockBorder"];
			if (isForTheater) {
				bonusBeastClass += ` ${styles.theaterBonusBeastImage}`;
				bonusBeastBorderClass += ` ${styles.theaterBonusBeastBorder}`;
			} else {
				bonusBeastClass += ` ${
					smaller ? styles.bonusBeastImageSmall : styles.bonusBeastImage
				}`;
				bonusBeastBorderClass += ` ${
					smaller ? styles.bonusBeastBorderSmall : styles.bonusBeastBorder
				}`;
			}

			const bonusImageBorder = <div className={bonusBeastBorderClass} />;
			const bonusImage = (
				<img
					className={bonusBeastClass}
					src={AssetsUtil.getGeneralIcon(
						"icon-bonus-beast-" + blockModel.gradeNumber
					)}
				/>
			);
			const bonusContent = (
				<React.Fragment>
					{bonusImageBorder}
					{bonusImage}
				</React.Fragment>
			);
			// Don't display tooltip if it's locked.
			return isUnlocked ? (
				<Tooltip tooltipText={CopyTable.tooltipText.bonusBlock} size="small">
					{bonusContent}
				</Tooltip>
			) : (
				bonusContent
			);
		},

		showHistoryMessage: function(messageType) {
			this.setState({historyModalType: messageType});
		},

		/* We want to show the HW icon once the assignment has become available
		   and then from then-on even after the student has finished the lesson */
		renderHWIcon: function() {
			const {block, user, homework = {}} = this.props;

			const blockModel = block.model;
			const {blockID} = blockModel;
			const {assignedBlocks} = homework || {};
			const thisAssignedBlock = assignedBlocks ? assignedBlocks[blockID] : null;

			if (thisAssignedBlock) {
				const homeworkData = OpsUser.getHomeworkDataForBlock(
					user,
					thisAssignedBlock
				);
				const isCurrentWeek = homeworkData.isCurrentWeek;

				const rd = _.get(thisAssignedBlock, "releaseDate");
				const releaseDate = rd && moment(rd);
				const isReleased = releaseDate && moment().isSameOrAfter(releaseDate);
				const hwLink = URLMake.forBlock(block);

				return isReleased && thisAssignedBlock ? (
					<Tooltip
						tooltipText={CopyTable.forBlockHomeworkIconTooltip(isCurrentWeek)}
						size="large"
						className={styles.hwContainer}
					>
						<StudentLink
							to={hwLink}
							useWonkyCursor={true}
							clickSound={"squishy"}
						>
							<img
								className={
									styles[isCurrentWeek ? "hwIconCurrent" : "hwIconPast"]
								}
								src={AssetsUtil.getHWIcon(true)}
							/>
							<div className={styles.hwShadow} />
						</StudentLink>
					</Tooltip>
				) : null;
			}

			return null;
		},

		renderStars: function() {
			const {block, user, isForTheater, onButtonClick} = this.props;
			const blockModel = block.model;
			const percentComplete = block.model.percentComplete;

			let starLink = URLMake.forBlockHistory(blockModel);
			const emptyResults = !blockModel.hasHistory;
			const stayOnSet = OpsUser.hasKey(user, "trainer stay on last set");
			let clickAction;
			let clickSound;

			if (stayOnSet) {
				starLink = URLMake.forBlockSummary(block);
			} else if (isForTheater) {
				starLink = null;
				clickAction = onButtonClick;
			} else if (percentComplete > 0) {
				starLink = null;
				clickSound = "squishy";
				clickAction = () => this.showHistoryMessage("inProgressHistory");
			} else if (emptyResults) {
				starLink = null;
				clickSound = "locked-lesson";
				clickAction = () => this.showHistoryMessage("emptyHistory");
			}

			if (this.props.overrideStarClick) {
				clickAction = () => this.props.overrideStarClick();
			}

			const starsObtained = _.isNumber(this.props.overrideStarsObtained)
				? this.props.overrideStarsObtained
				: blockModel.starsObtained;
			let containerClass =
				styles["starShape" + this.props.blockShapeNum] +
				" " +
				styles["starNum" + starsObtained];
			if (isForTheater) containerClass = styles.theaterBlockStar;

			let linkEl;

			if (starLink) {
				linkEl = (
					<BlockStar
						className={containerClass}
						type={"star-" + starsObtained}
						linkTo={starLink}
						clickSound={"squishy"}
					/>
				);
			} else {
				linkEl = (
					<BlockStar
						className={containerClass}
						type={"star-" + starsObtained}
						onClick={clickAction}
						clickSound={clickSound}
					/>
				);
			}
			const tooltipText =
				stayOnSet || this.props.disableStarTooltip || isForTheater
					? ""
					: CopyTable.tooltipText.history;
			return (
				<Tooltip
					className={this.props.starTooltipClass}
					tooltipText={tooltipText}
					size="small"
				>
					{linkEl}
				</Tooltip>
			);
		},

		showUnfinishedModal: function() {
			const {skipUnfinishedMessage, block, numUnfinishedBlocks} = this.props;
			return (
				!skipUnfinishedMessage &&
				!block.model.unfinished &&
				numUnfinishedBlocks >= 3
			);
		},

		renderModal: function() {
			const {block, chapter, user, demo} = this.props;
			const blockModel = block.model;
			const isUnlocked = this.isUnlocked();
			const isUnderConstruction = blockModel.underConstruction;
			const {isModalOpen, historyModalType} = this.state;
			let handleModalClose;

			if (isModalOpen) {
				handleModalClose = () => this.setState({isModalOpen: false});
				if (!isUnlocked || isUnderConstruction) {
					const message = CopyTable.forBlockLocked(
						block,
						chapter,
						user,
						null,
						demo
					);
					return (
						<MessageModal
							styleType="chapterPage"
							onClose={handleModalClose}
							buttonType="ok"
						>
							{message}
						</MessageModal>
					);
				}

				if (this.showUnfinishedModal()) {
					const handleStartBlock = () => {
						//First close the modal
						handleModalClose();
						//Then start the block
						this.startBlock();
					};

					return (
						<ChooseOptionModal
							buttons={[
								{buttonType: "yes", handleClick: handleStartBlock},
								{buttonType: "cancel", handleClick: handleModalClose},
							]}
							onClose={handleModalClose}
						>
							{CopyTable.forUnfinishedBlocks(this.props.numUnfinishedBlocks)}
						</ChooseOptionModal>
					);
				}
			} else if (historyModalType) {
				handleModalClose = () => this.setState({historyModalType: false});
				const confirmType =
					historyModalType === "emptyHistory" ? "getstarted" : "keepplaying";
				return (
					<MessageModal
						styleType="default"
						buttonType={confirmType}
						buttonClickHandler={this.startBlock}
						onClose={handleModalClose}
					>
						{CopyTable.forErrorMessageType(historyModalType)}
					</MessageModal>
				);
			}

			return null;
		},

		// Returns an {__html} object to use with React's dangerously set inner HTML.
		getBlockTitle: function(name) {
			name = name.replace(/\&/, "&amp;");
			name = name.replace(/\</, "&lt;");
			name = name.replace(/\>/, "&gt;");
			// Remove parentheses at end
			name = name.replace(/ \(.*$/, "");
			// If last word short, put a nonbreaking space before it.
			name = name.replace(/ (.{1,2})$/, "&nbsp;$1");
			return {__html: name};
		},

		onButtonClick: function() {
			if (
				this.props.isForTheater &&
				this.props.demo &&
				this.blockHasBeenCompleted()
			) {
				// no-op (will be handled by replay functionality)
			} else if (this.props.onButtonClick) {
				this.props.onButtonClick();
			} else {
				this.setState({isModalOpen: true});
				const soundName = this.isUnlocked() ? "lesson-click" : "locked-lesson";
				Sounds.playSound(soundName);
			}
		},

		onClickDemoLessonToReplay: function() {
			if (!this.props.demoReplayBlockId) {
				this.props.dispatch({
					type: AT.ATTEMPT_REPLAY_DEMO_LESSON,
					blockID: this.props.block.blockID,
				});
			} else {
				// restart demo block
				this.props.dispatch({
					type: AT.REPLAY_DEMO_BLOCK,
					blockID: this.props.block.blockID,
				});
			}
		},

		blockHasBeenCompleted: function() {
			const historyResults = _.get(this.props.block, ["history", "allResults"]);
			return historyResults && historyResults.length > 0;
		},

		render: function() {
			const {
				block,
				assignedBlock,
				chapter,
				isForTheater,
				titleClassName,
				demo,
				demoHighlight,
				user,
				topText,
			} = this.props;
			const blockModel = block.model;
			const isUnlocked = this.isUnlocked();
			const underConstruction = !isForTheater && blockModel.underConstruction;

			const background = this.renderBlockBackground(
				blockModel.gradeNumber,
				this.props.blockShapeNum
			);

			let buttonClass = topText ? styles.buttonWithTopText : styles.button;
			//Only rendering a trophy, stars, and unfinished icon if unlocked
			let blockTrophy = null;
			let blockStars = null;
			let unfinishedIcon = null;
			let hwIcon = null;
			if (isUnlocked && !underConstruction) {
				blockStars = this.renderStars();
				if (!isForTheater) {
					blockTrophy = this.renderTrophy(this.props.smaller);
					unfinishedIcon = this.renderUnfinishedIcon(this.props.smaller);
				}
				hwIcon = this.renderHWIcon();
			}
			let lockIcon = null;
			if (!isUnlocked) {
				lockIcon = this.renderLockIcon();
			} else if (underConstruction) {
				lockIcon = this.renderConstructionIcon();
				buttonClass += " " + styles.construction;
			}

			const modal = isForTheater ? null : this.renderModal();

			const name = this.getBlockTitle(blockModel.displayName);

			let beastClass = styles.beast;
			let titleContainerClass = styles.titleContainer;
			if (this.props.overrideBeastClass) {
				beastClass = this.props.overrideBeastClass;
			} else if (this.props.smaller && this.props.largerTitle) {
				beastClass = styles.sGridLTitleBeast;
				titleContainerClass = styles.sGridLTitleContainer;
			} else if (this.props.smaller) {
				beastClass = styles.smallGridBeast;
			} else if (this.props.largerTitle) {
				beastClass = styles.largeTitleBeast;
				titleContainerClass = styles.largeTitleContainer;
			} else if (topText) {
				beastClass = styles.beastWithTopText;
			}

			if (this.props.overrideTitleContainerClass) {
				titleContainerClass = this.props.overrideTitleContainerClass;
			}

			if (titleClassName) {
				titleContainerClass += ` ${titleClassName}`;
			}

			titleContainerClass += ` ${styles.whiteText}`;

			let beastImage = null;
			if (!isUnlocked || !underConstruction) {
				beastImage = (
					<img
						className={beastClass}
						src={AssetsUtil.getBlockBeast(
							this.props.demo ? 4 : blockModel.gradeNumber,
							blockModel.beast,
							isUnlocked
						)}
					/>
				);
			}

			const bonusBeastIcon = this.renderBonusBeastIcon(isUnlocked);

			let topTextEl = null;
			if (topText)
				topTextEl = <span className={styles.topText}>{topText}</span>;

			const btn = (
				<div className={buttonClass} onClick={this.onButtonClick}>
					{background}
					{topTextEl}
					{bonusBeastIcon}
					{beastImage}
					<div className={titleContainerClass + " " + styles.blockTitle}>
						<div className={styles.title} dangerouslySetInnerHTML={name} />
					</div>
					{lockIcon}
					<Tooltip
						tooltipText={CopyTable.tooltipText.unfinishedBlock}
						size="medium"
					>
						{unfinishedIcon}
					</Tooltip>
				</div>
			);
			let mainClass = styles.main;
			if (!isForTheater) {
				mainClass += ` ${styles.mainWidth}`;
			}
			if (demoHighlight) mainClass += " " + styles.demoHighlight;
			const isUnderConstruction =
				!FLAGS.accessUnderConstructionBlocks && underConstruction;
			if ((!FLAGS.accessLockedBlocks && !isUnlocked) || isUnderConstruction) {
				return (
					<div className={mainClass}>
						<Tooltip
							tooltipText={CopyTable.forBlockLocked(
								block,
								chapter,
								user,
								null,
								null,
								demo
							)}
							className={styles.tooltip}
							size="large"
						>
							{btn}
						</Tooltip>
						{blockTrophy}
						{modal}
					</div>
				);
			} else {
				//Decide to add the link or not based on whether to show a modal about
				//having too many unfinished lessons:
				let wrappedBtn;
				if (this.showUnfinishedModal()) {
					wrappedBtn = <div className={styles.buttonWrapper}>{btn}</div>;
				} else if (isForTheater) {
					if (demo && this.blockHasBeenCompleted()) {
						wrappedBtn = (
							<div
								className={styles.buttonWrapper}
								onClick={this.onClickDemoLessonToReplay}
							>
								{btn}
							</div>
						);
					} else {
						wrappedBtn = <div className={styles.buttonWrapper}>{btn}</div>;
					}
				} else if (demo && this.blockHasBeenCompleted()) {
					wrappedBtn = (
						<div
							className={styles.buttonWrapper}
							onClick={this.onClickDemoLessonToReplay}
						>
							{btn}
						</div>
					);
				} else if (this.props.disableLink !== true) {
					const url = URLMake.forBlock(block);
					wrappedBtn = (
						<StudentLink to={url} useWonkyCursor={true}>
							{btn}
						</StudentLink>
					);
				} else {
					wrappedBtn = btn;
				}

				let toDoEl = null;

				if (
					!_.isUndefined(assignedBlock) &&
					!OpsUser.isAcademyUser(this.props.user)
				) {
					toDoEl = this.renderToDoClip(assignedBlock.starsObtained === 0);
				}

				return (
					<div className={mainClass}>
						{wrappedBtn}
						{toDoEl}
						{blockTrophy}
						{hwIcon}
						{blockStars}
						{modal}
					</div>
				);
			}
		},
	})
);
